import React from 'react';
import numeral from 'numeral';
import CirculatingIcon from '../../icons/CirculatingIcon';
import TotalSupplyIcon from '../../icons/TotalSupplyIcon';
import BurntSupplyIcon from '../../icons/BurntSupplyIcon';
import TreasuryIcon from '../../icons/TreasuryIcon';
import './CirculatingSupply.css';
import history from "../history";

const isSomething = val => !(val === undefined || val === null);
const withRequest = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        request: null,
        error: null,
        circulatingSupply: null,
        totalSupply: null
      };
    }
    componentDidMount() {
      this.setState({ request: fetch('https://supply.xdbchain.com') });
    }
    render() {
      const maxSupply = 20000000000;
      const burntSupply = 1190514148; // balance of GC7GH763TKNVOWOOLOZR4ZYHHDSJIYJPP746ZFNEQZLJHB244WBBBBRN
      const officialTreasury = 1708699937; // balance of GBMOHKO3CVEJSMUXCJ3WZR5DIZAL33LVLH7CRRXLMV5X655WHPS5R222

      const totalSupply = maxSupply - burntSupply; // props.total_supply
      const circulatingSupply = totalSupply - officialTreasury; // props.circulating_supply
      return (
        <WrappedComponent
          {...this.state}
          setValue={props => this.setState({
            request: null,
            error: null,
            totalSupply: totalSupply,
            circulatingSupply: circulatingSupply,
            burntSupply: burntSupply,
            officialTreasury: officialTreasury
          })}
          setError={error => this.setState({ error })}
        />
      )
    }
  }
};

const CardValue = ({ error, amount }) => (
  <div className="card-bottom">
    {!error && amount
      ? numeral(amount).format('0,0').toUpperCase()
      : '0.00'}
  </div>
);

const CirculatingSupply = ({ totalSupply, request, circulatingSupply, burntSupply, officialTreasury, error, setValue, setError }) => {
  if (!totalSupply && !circulatingSupply && !error && !burntSupply && request) {
    request
      .then(res => res.ok
        ? res
        : Promise.reject('Error loading data'))
      .then(res => res.json())
      .then(setValue)
      .catch(setError);
  }

  return (
    <div className="content-wrapper">
      <div className="cards">
        {isSomething(burntSupply) && (
          <div className="circulating-card"
               onClick={() => {
               history.push("/address/GC7GH763TKNVOWOOLOZR4ZYHHDSJIYJPP746ZFNEQZLJHB244WBBBBRN");
             }}>
            {error && <div className="loading-error">There was an error loading your data</div>}
            <div className="card-content">
              <div className="card-top">
                <BurntSupplyIcon />
                <div>Burnt Supply</div>
              </div>
              <CardValue error={error} amount={burntSupply} />
              <div className="card-details">
                Last burn: <a href="/transaction/37c45c73a8b1cf149f713ecedfb40a4a4fc5e762aae95155a607e886f6500f1b/">Oct 1st 2024</a><br/>
                {/* Next burn coming on <strong>Oct 1st 2024</strong> */}
              </div>
            </div>
          </div>
        )}
        <div className="circulating-card"
             onClick={() => {
               history.push("/address/GBMOHKO3CVEJSMUXCJ3WZR5DIZAL33LVLH7CRRXLMV5X655WHPS5R222");
             }}>
          {error && <div className="loading-error">There was an error loading your data</div>}
          <div className="card-content">
            <div className="card-top">
              <TreasuryIcon />
              <div>Official Treasury</div>
            </div>
            <CardValue error={error} amount={officialTreasury} />
          </div>
        </div>
        <div className="circulating-card">
          {error && <div className="loading-error">There was an error loading your data</div>}
          <div className="card-content">
            <div className="card-top">
              <CirculatingIcon />
              <div>Circulating Supply</div>
            </div>
            <CardValue error={error} amount={circulatingSupply} />
          </div>
        </div>
        {isSomething(totalSupply) && (
          <div className="circulating-card">
            {error && <div className="loading-error">There was an error loading your data</div>}
            <div className="card-content">
              <div className="card-top">
                <TotalSupplyIcon />
                <div>Total Supply</div>
              </div>
              <CardValue error={error} amount={totalSupply} />
            </div>
          </div>
        )}
        </div>
      <div className="pattern" />
    </div>
  );
};

export default withRequest(CirculatingSupply);



// WEBPACK FOOTER //
// ./src/components/CirculatingSupply/CirculatingSupply.js